import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=91d34cb6&scoped=true&lang=pug"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=91d34cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d34cb6",
  null
  
)

export default component.exports